"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AgreementForm = function AgreementForm(_ref) {
  var initiatorName = _ref.initiatorName,
      onNextClick = _ref.onNextClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex bg-cyan-500 justify-around items-center h-full w-full text-primary"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "sm:w-1/2 lg:w-1/2 xl:w-2/5 2xl:w-1/3 bg-white pt-5 pl-12 pr-12 pb-5 flex flex-col text-base rounded"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicplaceLogo, {
    height: "90",
    width: "280",
    className: "self-center mb-10"
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.agreements.header.left"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-bold"
    }, value);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.agreements.text.left.invite",
    values: {
      name: initiatorName
    }
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "my-5"
    }, value);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.agreements.text.left.release"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "mt-5"
    }, value);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.agreements.text.left.control"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "mb-5"
    }, value);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.agreements.text.left.share"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "my-5"
    }, value);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.agreements.text.left.observance"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "mt-5"
    }, value);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.agreements.text.left.necessary"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "mb-5"
    }, value);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.agreements.text.left.confirm"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "my-5"
    }, value);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    onClick: onNextClick,
    className: "self-center my-4",
    primary: true,
    raised: true
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.agreements.button",
    tagName: "span"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hidden sm:block w-2/5 text-base text-white font-bold"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.language.header.right"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("h3", {
      className: "uppercase text-4xl mb-8"
    }, value);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "portal.registration.language.text.right"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("h3", {
      className: "text-xl mb-8"
    }, value);
  })));
};

var noop = function noop() {};

AgreementForm.propTypes = {
  initiatorName: _propTypes["default"].string,
  onNextClick: _propTypes["default"].func
};
AgreementForm.defaultProps = {
  initiatorName: '',
  onNextClick: noop
};
var _default = AgreementForm;
exports["default"] = _default;